"use client"

import { FragmentType, graphql, useFragment } from "@/gql"
import type { NovaSession } from "@/types"
import { FC, useCallback, useEffect } from "react"
import { ProjectDesktopContent } from "./ProjectDesktopContent"
import { ProjectMobileContent } from "./ProjectMobileContent"

const ProjectPageBodyFragment = graphql(`
  fragment ProjectPageBody on CreativeWorkPortfolioProject {
    __typename
    id
    creator {
      id
      creative {
        id
        handle
      }
    }
    ...ProjectDesktopContent
    ...ProjectMobileContent
  }
`)

interface Props {
  serverSession: NovaSession | null
  project: FragmentType<typeof ProjectPageBodyFragment> | undefined | null
  isViewersProject: boolean
}

export const ProjectPageBody: FC<Props> = ({ serverSession, isViewersProject, ...props }) => {
  const project = useFragment(ProjectPageBodyFragment, props.project)

  const userHref = `/${project?.creator?.creative?.handle}`

  const handleProjectView = useCallback(() => {
    if (project?.id) {
      fetch("/api/view/project", {
        method: "POST",
        body: JSON.stringify({ id: project.id }),
      })
    }
  }, [project])

  useEffect(() => {
    handleProjectView()
  }, [handleProjectView])

  return (
    <div className="mx-auto w-full max-w-xl px-5 md:px-8 lg:px-9">
      <div className="hidden h-full md:block">
        <ProjectDesktopContent
          userHref={userHref}
          project={project}
          serverSession={serverSession}
          isViewersProject={isViewersProject}
        />
      </div>
      <div className="block md:hidden">
        <ProjectMobileContent
          serverSession={serverSession}
          userHref={userHref}
          project={project}
          isViewersProject={isViewersProject}
        />
      </div>
    </div>
  )
}
